export default "__VITE_ASSET__hQDLvHqa__"